export function timeFix () {
    const time = new Date()
    const hour = time.getHours()
    return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
    const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '祝你开心每一天']
    const index = Math.floor(Math.random() * arr.length)
    return arr[index]
}

/**
 * CRM客户管理-客户类型
 */
export function customerTypes () {
    const TypesMap = {
        1: { value: '机构', color: 'pink' },
        2: { value: '厂商', color: 'green' },
        3: { value: '个人', color: 'orange' }
    }
    return TypesMap
}

/**
 * CRM客户管理-客户意向
 */
export function cooperation () {
    const arr = {
        1: { value: '积极', color: 'pink' },
        2: { value: '一般', color: 'green' },
        3: { value: '低', color: 'orange' },
        4: { value: '不合作', color: 'red' }
    }
    return arr
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
    const event = document.createEvent('HTMLEvents')
    event.initEvent('resize', true, true)
    event.eventType = 'message'
    window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
    let timer = 0

    let beforeScrollTop = window.pageYOffset
    callback = callback || function () {}
    window.addEventListener(
        'scroll',
        event => {
            clearTimeout(timer)
            timer = setTimeout(() => {
                let direction = 'up'
                const afterScrollTop = window.pageYOffset
                const delta = afterScrollTop - beforeScrollTop
                if (delta === 0) {
                    return false
                }
                direction = delta > 0 ? 'down' : 'up'
                callback(direction)
                beforeScrollTop = afterScrollTop
            }, 50)
        },
        false
    )
}

export function isIE () {
    const bw = window.navigator.userAgent
    const compare = (s) => bw.indexOf(s) >= 0
    const ie11 = (() => 'ActiveXObject' in window)()
    return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
    if (id === '') {
        return
    }
    setTimeout(() => {
        document.body.removeChild(document.getElementById(id))
    }, timeout)
}

/**
 * 随机颜色
 * @jdy
 * @2021-3-18
 */
export function getRandomColor () {
    const color = '#' + '0123456789abcdef'.split('').map(function (v, i, a) {
        return i > 5 ? null : a[Math.floor(Math.random() * 16)]
    }).join('')
    return color
}

/**
 * 随机颜色
 * @jdy
 * @2021-3-18
 */
export function getRandomLightColor () {
    const arr = ['pink', 'red', 'orange', 'green', 'cyan', 'blue', 'purple', 'yellow', 'geekblue', 'magenta', 'volcano', 'gold', 'lime']
    return arr[Math.floor(Math.random() * arr.length)]
}
/**
 * 数组获取id值生成新数组
 * @param {*} oldArr
 * @returns
 */
export function handleSelectArr (oldArr) {
    const newArr = oldArr.map(item => item.id)
    return newArr
}

/**
 * 随机颜色
 * @jdy
 * @2021-3-18
 */
export function getArrayIDToString (arr) {
    const value = arr.map(item => item.id)
    return value.join(',')
}
